module.exports = __webpack_public_path__ + "static/media/netflix-zuul.af93b6ce.png";